import { firebase } from "../../../services/firebase";
import { toast } from "react-toastify";
import httpClient from "../../../custom-hooks/httpClient";

const documentUploadUrl = `/identity-documents`;
// const headers = {
//   headers: {
//     "Content-Type": "application/json",
//   },
// };

export const firebaseImageUpload = (document) => {
  return new Promise((resolve, reject) => {
    const storage = firebase.storage();
    storage
      .ref(`images/${document.name}`)
      .put(document)
      .on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          reject("error uploading document");
        },
        () => {
          storage
            .ref("images")
            .child(document.name)
            .getDownloadURL()
            .then(resolve)
            .catch(reject);
        }
      );
  });
};

export const identityDocumentUpload = async (payload, resetDefault) => {
  try {
    const response = await httpClient.post(documentUploadUrl, { payload }); //, headers
    const { status, data } = response;
    return { status, data };
  } catch (err) {
    resetDefault();
    if (
      err.response.data.message === "Error adding client identifier document"
    ) {
      return toast.error("Document Already Exists");
    } else {
      return toast.error(err.response.data.message);
    }
  }
};

export const postBvnUpdate = async (payload, user, resetDefault) => {
  try {
    const response = await httpClient.post(`/users/${user.id}/update-bvn`, { payload }); //, headers
    const { data } = response;
    return { data };
  } catch (err) {
    let errorMessage = err.response.data.message;
    let message =
      "Invalid body parameter bvn. Should be a string of eleven digits";
    if (errorMessage === message) {
      toast.error(`Error Updating BVN : BVN ${errorMessage.substr(28)}`);
    } else {
      toast.error("Error Updating BVN");
    }
    resetDefault();
  }
};

export const getIdentityDocumentTypes = async () => {
  try {
    const response = await httpClient.get(documentUploadUrl); // , headers
    const { data, status } = response;

    return { data, status };
  } catch (err) {
    return toast.error(err.response.data.message);
  }
};

export const getUploadedDocuments = async (user) => {
  try {
    const response = await httpClient.post(`/users/${user.id}/get-identity-documents`, {}); // , headers
    const { data, status } = response;

    return { data, status };
  } catch (err) {
    return toast.error(err);
  }
};
